import React from "react";
import { useState, useEffect } from "react";
import { TitleComponent, CardComponent, TableComponent, ButtonActionComponent,SelectComponent } from '../../components/pages/index';
import { api, apiConfig } from "../../util/api";
import HeaderMenu from '../layout/headerMenu';
import { useGetApiWs } from '../../hooks/index';

const Request = (props) => {
    const urlCustonerInfo = useGetApiWs('admin', 'entity', 'category-get');
    const urlRequest = useGetApiWs('admin', 'entity', 'sku-get')

    const [lbCategory, setLbCategory] = useState(null);

    const [category, setCategory] = useState([]);
    const [categoryIsLoading, setCategoryIsLoading] = useState(true);

    const [tbHeadings, setTbDataHeadings] = useState([]);
    const [btnExports, setBtnExports] = useState(false);
    const [tbColumns, setTbColumns] = useState([]);
    const [tbData, setTbData] = useState([]);
    const [tbPending, setTbPending] = useState(false);


    const fetchCategory = async () => {
        const ob = {}
        const cWorkOrders = await api().post(urlCustonerInfo,ob, apiConfig());
        if (cWorkOrders.status === 200 && cWorkOrders.data.status === 'success') {
            var options = cWorkOrders.data.response.map(obj => {
                var rObj = {};
                rObj['value'] = obj.category_id;
                rObj['label'] = obj.name;
                return rObj;
            })
            setCategory(options);
        }
        setCategoryIsLoading(false);
    }

    const CategoryChange = async vals => {
        setLbCategory(vals);
        setBtnExports(false);
        if (vals === null) {
        } else {
        }
    }

    const fetchFilters = async () => {
        if (lbCategory != null) {
            setTbPending(true);
            const ob = {}
            ob['category_id'] = lbCategory.value;
            var headers = [];
            const res = await api().post(urlRequest, ob, apiConfig());
            if (res.data.status === 'success') {
                let colum = [];
                if (res.data.response.length > 0) {
                    const head = res.data.response[0]
                    headers = Object.keys(head)
                    for (var h in headers) {
                        colum.push({
                            name: headers[h], selector: headers[h], sortable: false, wrap: true
                        })
                    }
                    setBtnExports(true);
                    setTbColumns(colum);
                    setTbData(res.data.response);
                    setTbPending(false);
                } else {
                    setBtnExports(false);
                    setTbColumns([]);
                    setTbData([]);
                    setTbPending(false);
                }
            }
        }
    }
    const Filter = ()=>{
        fetchFilters();
    }

    useEffect(() => {
        fetchCategory();
    }, [])

    return (
        <div>
            <div className='HeaderContent'>
                <div>
                    <TitleComponent title="Archivo Consulta General" />
                </div>
                <div>
                    <HeaderMenu handleToogleSideBar={""} />
                </div>
            </div>
            <div>
                <CardComponent header={null} footer={null}>
                    <div className="bg-white p-2 pb-5">
                        <div className="grid md:grid-cols-6 lg:grid-cols-6 items-center gap-4">
                            <SelectComponent onChange={CategoryChange} options={category} value={lbCategory} isLoading={categoryIsLoading} label="Categoría" />
                        </div>
                        <div className="mt-2">
                            <ButtonActionComponent name="GENERAR" onClick={Filter} />
                        </div>
                    </div>
                </CardComponent>
            </div>
            <div id="list" className="list pt-3">
                <CardComponent header={<h4 className="">Distribución</h4>} footer={null}>
                    <div className="bg-white">
                        <div>
                        </div>
                        <TableComponent
                            keyField="work_order_id"
                            columns={tbColumns}
                            headItem={tbHeadings}
                            data={tbData}
                            pending={tbPending}
                            highlightOnHover={true}
                        />
                    </div>
                </CardComponent>
            </div>
        </div>
    )
}

export default Request